// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"29139b5e","147":"1e7039e8","191":"b38158c5","212":"50188b85","243":"6eda2ae9","453":"ddf87a13","615":"b1e1fa89","844":"7a91eef3","997":"50f9df6d"}[chunkId] + ".chunk.js";
};